"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentTermsMap = exports.paymentTerms = exports.mapReservationStatusToItem = exports.mapReservationPaymentStatusToItem = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const reservationPaymentStatusLabels = {
    paid: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Paid', defaultMessage: 'Paid' })),
    unpaid: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Unpaid', defaultMessage: 'Unpaid' })),
};
const mapReservationPaymentStatusToItem = (value) => ({
    value,
    label: reservationPaymentStatusLabels[value],
});
exports.mapReservationPaymentStatusToItem = mapReservationPaymentStatusToItem;
const reservationStatusLabels = {
    created: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Pending', defaultMessage: 'Pending' })),
    confirmed: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Confirmed', defaultMessage: 'Confirmed' })),
    reserved: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Reserved', defaultMessage: 'Reserved' })),
    cancelled: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:Cancelled', defaultMessage: 'Cancelled' })),
};
const mapReservationStatusToItem = (value) => ({
    value,
    label: reservationStatusLabels[value],
});
exports.mapReservationStatusToItem = mapReservationStatusToItem;
exports.paymentTerms = [
    'now',
    'later',
    'bill',
    'airport',
];
exports.paymentTermsMap = {
    now: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:PaymentTermsNow', defaultMessage: 'Pay now' })),
    later: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:PaymentTermsLater', defaultMessage: 'Pay later' })),
    bill: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:PaymentTermsBill', defaultMessage: 'Pay by invoice' })),
    airport: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:PaymentTermsAirport', defaultMessage: 'Pay in airport' })),
};
//# sourceMappingURL=utils.js.map